<mat-card class="cardWithShadow dashboard-card">
  <mat-card-content class="dashboard-card-content">
    <div class="d-flex justify-content-between">
      <mat-card-title class="dashboard-card-title">
        {{ 'dashboard.case_status' | translate }}
      </mat-card-title>
      <div class="text-end">
        <p class="dashboard-metric-label">{{ 'dashboard.open' | translate }}</p>
        <p class="dashboard-metric-value">{{ kpi().openAmount | currency }}</p>
      </div>
    </div>

    <app-claim-status-chart
      [successRate]="kpi().successRate"
      [statusesApi]="kpi().caseStatuses"
      [statusSummary]="kpi().statusSummary"
      (statusSelected)="onStatusSelected($event)" />

    <p class="dashboard-case-status-info">
      <mat-icon class="dashboard-case-status-info__icon">info</mat-icon>
      <span>{{ 'dashboard.case_status_open_info' | translate }}</span>
    </p>
  </mat-card-content>
</mat-card>
